import { Grid } from "@mui/material";
import { AffectedSprsTable } from "./AffectedSprsTable";
import { TtProtectionFilterForm } from "./TtProtectionFilterForm";

export const AffectedSprsForm = () => {
  return (
    <Grid container>
      <Grid item xs={4}>
        <AffectedSprsTable />
      </Grid>
      <Grid item xs={8}>
        <TtProtectionFilterForm />
      </Grid>
    </Grid>
  );
};
